import { node } from 'prop-types';
import React, { createContext, Component } from 'react';

import MOCK_EXPERIENCES from './mocks/experiences.json';
import MOCK_STORIES from './mocks/stories.json';

const Context = createContext();
const { Provider, Consumer: ConsumerData } = Context;

class ProviderData extends Component {
  static propTypes = {
    children: node,
  };

  static defaultProps = {
    children: undefined,
  };

  state = {
    dictionary: undefined,
    experience: undefined,
    experiences: MOCK_EXPERIENCES,
    story: undefined,
    stories: MOCK_STORIES,
  }

  onData = (key, value) => this.setState({ [key]: value });

  render() {
    const {
      onData, onError, props: { children },
    } = this;

    return (
      <Provider
        value={{
          ...this.state, onData, onError,
        }}
      >
        { children }
      </Provider>
    );
  }
}

export { ConsumerData, ProviderData };
